export default __webpack_public_path__ + "f04dfee887674fda8ce19b49c74b614e.wasm";